import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { COLORS } from '../constants/styles';

export default class DefaultButtonIcon extends Component {
    static propTypes = {
        isBrandColorDark: PropTypes.bool.isRequired,
    };

    render() {
        const { isBrandColorDark } = this.props;

        return (
            <svg
                id="default-button-icon"
                height="26"
                viewBox="0 0 38 29"
                width="35"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    enableBackground: 'new 0 0 100 100',
                    overflow: 'visible',
                    shapeRendering: 'geometricPrecision',
                }}
            >
                <path
                    d="m104.466667 53.1714286-7.0571432 6.9512857v-6.9512857zm11.761904-21.1714286c5.196737 0 9.409524 4.2127873 9.409524 9.4095238s-4.212787 9.4095238-9.409524 9.4095238h-18.8190472c-5.1967365 0-9.4095238-4.2127873-9.4095238-9.4095238s4.2127873-9.4095238 9.4095238-9.4095238z"
                    fill={isBrandColorDark ? COLORS.WHITE : COLORS.GRAY_SCARPA}
                    transform="translate(-88 -32)"
                />
            </svg>
        );
    }
}
